import { Fancybox } from "@fancyapps/ui";

export default new (class FancyboxPreview {
    constructor() {
        this.videoYt = '[data-fancybox-yt]'
        this.videoRutube = '[data-fancybox-rutube]'
        this.sliderGalleryPreviewWrap = 'fancybox-gallery-wrap'
        this.sliderGalleryPreview = '[data-fancybox="gallery"]:not(.swiper-slide-duplicate)'
        this.handler()
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.initFancybox()
        })
    }

    initFancybox() {
        document.querySelectorAll(`.${this.sliderGalleryPreviewWrap}`).forEach((item) => {
            if(item.getAttribute('id') != "photo") {
                Fancybox.bind(`#${item.getAttribute('id')} ${this.sliderGalleryPreview}`, {
                    groupAll: true,
                    infinite: false,
                    placeFocusBack: true,
                    animated: false,
                    closeButton: "outside",
                    mainClass: "fancybox-custom",
                    showClass: false,
                    hideClass: false,
                    template : {
                        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
                    },
                    on: {
                        ready: (fancybox) => {
                            if(document.querySelector('.can-zoom_in')) {
                                document.querySelectorAll('.can-zoom_in').forEach(element => {
                                    element.classList.remove(can-zoom_in);
                                });
                            }
                            if(fancybox.items.length > 1) {
                                document.querySelector('.carousel__button.is-next').innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.705 11.6189L9.28611 1.19995L7.20233 3.28373L15.5366 11.618L7.19922 19.9553L9.283 22.0391L17.6204 13.7018L17.6212 13.7026L19.705 11.6189Z" fill="#004B8B"/></svg>'
                                document.querySelector('.carousel__button.is-prev').innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.29497 11.6189L14.7139 1.19995L16.7977 3.28373L8.46342 11.618L16.8008 19.9553L14.717 22.0391L6.37964 13.7018L6.37876 13.7026L4.29497 11.6189Z" fill="#004B8B"/></svg>'
                            }
                            document.querySelector('.fancybox__button--close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'

                            if(document.querySelector('.fancybox__carousel') && document.querySelector('.fancybox__counter')) {
                                document.querySelector('.fancybox__carousel').insertAdjacentHTML('afterend', '<div class="fancybox__bottom"><div class="fancybox__counter">' + document.querySelector('.fancybox__counter').innerHTML + '</div></div>');
                            }
                            else {
                                document.querySelector('.fancybox__carousel').insertAdjacentHTML('afterend', '<div class="fancybox__bottom"><div class="fancybox__counter"></div></div>');
                            }
                            if(item.getAttribute('data-download') != "") {
                                document.querySelector('.fancybox__bottom').innerHTML += '<a download href="' + item.getAttribute('data-download')+' " class="link link-all"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6714 9.9663L14.3785 9.2592L12.9643 7.84498L12.2572 8.55209L13.6714 9.9663ZM9.99972 12.2238L9.29262 12.9309L9.99972 13.638L10.7068 12.9309L9.99972 12.2238ZM7.74226 8.55209L7.03516 7.84498L5.62094 9.2592L6.32805 9.9663L7.74226 8.55209ZM11.0007 3.00024V2.00024H9.00065V3.00024H11.0007ZM9.00065 11.0002V12.0002H11.0007V11.0002H9.00065ZM12.2572 8.55209L9.29262 11.5167L10.7068 12.9309L13.6714 9.9663L12.2572 8.55209ZM10.7068 11.5167L7.74226 8.55209L6.32805 9.9663L9.29262 12.9309L10.7068 11.5167ZM9.00065 3.00024V11.0002H11.0007V3.00024H9.00065Z" fill="#4592D3"/><path d="M16 14V17H4V14" stroke="#4592D3" stroke-width="2"/></svg>Скачать все фото</a>';
                            }
                        },
                        reveal: (fancybox, slide) => {
                            slide.$content.innerHTML += '<a download href="' + slide.download+' " class="link"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6714 9.9663L14.3785 9.2592L12.9643 7.84498L12.2572 8.55209L13.6714 9.9663ZM9.99972 12.2238L9.29262 12.9309L9.99972 13.638L10.7068 12.9309L9.99972 12.2238ZM7.74226 8.55209L7.03516 7.84498L5.62094 9.2592L6.32805 9.9663L7.74226 8.55209ZM11.0007 3.00024V2.00024H9.00065V3.00024H11.0007ZM9.00065 11.0002V12.0002H11.0007V11.0002H9.00065ZM12.2572 8.55209L9.29262 11.5167L10.7068 12.9309L13.6714 9.9663L12.2572 8.55209ZM10.7068 11.5167L7.74226 8.55209L6.32805 9.9663L9.29262 12.9309L10.7068 11.5167ZM9.00065 3.00024V11.0002H11.0007V3.00024H9.00065Z" fill="#4592D3"/><path d="M16 14V17H4V14" stroke="#4592D3" stroke-width="2"/></svg>Скачать</a>'
                        },
                    }
                });
            }
            else {
                Fancybox.bind(`#${item.getAttribute('id')} ${this.sliderGalleryPreview}`, {
                    groupAll: false,
                    groupAttr: false,
                    infinite: false,
                    placeFocusBack: true,
                    animated: false,
                    closeButton: "outside",
                    mainClass: "fancybox-custom fancybox__container_recipe-step",
                    showClass: false,
                    hideClass: false,
                    template : {
                        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
                    },
                    on: {
                        ready: (fancybox) => {
                            if(document.querySelector('.can-zoom_in')) {
                                document.querySelectorAll('.can-zoom_in').forEach(element => {
                                    element.classList.remove(can-zoom_in);
                                });
                            }
                            document.querySelector('.fancybox__button--close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'
                        }
                    },
                    Image: {
                        wheel: false,
                        click: 'close',
                        zoom: false,
                    },
                });
            }
        });
        // document.querySelectorAll(`${this.videoYt}`).forEach((item) => {
        //     console.log(item);
        if(document.querySelector(`${this.videoYt}`)) {
            Fancybox.bind('[data-fancybox-yt]', {
                groupAll: false,
                groupAttr: false,
                infinite: false,
                placeFocusBack: true,
                animated: false,
                closeButton: "outside",
                mainClass: "fancybox-custom",
                showClass: false,
                hideClass: false,
                template : {
                    main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
                },
                on: {
                    ready: (fancybox) => {
                        if(document.querySelector('.can-zoom_in')) {
                            document.querySelectorAll('.can-zoom_in').forEach(element => {
                                element.classList.remove(can-zoom_in);
                            });
                        }
                        if(document.querySelector('.carousel__button.is-close')) {
                            document.querySelector('.carousel__button.is-close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'
                        }
                    },
                    reveal: (fancybox, slide) => {
                        if(document.querySelector('.carousel__button.is-close')) {
                            document.querySelector('.carousel__button.is-close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'
                        }
                    }
                }
            });
        }
        if(document.querySelector(`${this.videoRutube}`)) {
            Fancybox.bind('[data-fancybox-rutube]', {
                groupAll: false,
                groupAttr: false,
                infinite: false,
                placeFocusBack: true,
                animated: false,
                closeButton: "outside",
                mainClass: "fancybox-custom fancybox__rutube",
                showClass: false,
                hideClass: false,
                template : {
                    main: '<div class="fancybox__container fancybox__rutube" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
                },
                on: {
                    ready: (fancybox) => {
                        if(document.querySelector('.can-zoom_in')) {
                            document.querySelectorAll('.can-zoom_in').forEach(element => {
                                element.classList.remove(can-zoom_in);
                            });
                        }
                        if(document.querySelector('.carousel__button.is-close')) {
                            document.querySelector('.carousel__button.is-close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'
                        }
                    },
                    reveal: (fancybox, slide) => {
                        if(document.querySelector('.carousel__button.is-close')) {
                            document.querySelector('.carousel__button.is-close').innerHTML = '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6367 20.3633L35.6367 34.3633M21.6367 33.8448L35.6367 20.3633" stroke="#162B43" stroke-width="2.54545" stroke-linecap="square" stroke-linejoin="round"/></svg>'
                        }
                    }
                }
            });
        }
    }
})()
